<template>
  <div>
    <search-profile-inventory @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showImportModal"
          v-if="isShowMenu('profile_inventories/import')"
        >入库</a-button>

        <a-button
          type="primary"
          @click="showDestroyModal"
          v-if="isShowMenu('profile_inventories/delete')"
        >删除Profile</a-button>

        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <import-profile-inventory
      v-if="isShowImportModal"
      :visible.sync="isShowImportModal"
      @completed="fetchData"
    />

    <destroy-profile-inventory
      v-if="isShowDestroyModal"
      :visible.sync="isShowDestroyModal"
      :iccids="selectedIccids"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findProfileInventories, exportProfileInventories } from '@/api/profile_inventory'
import Pagination from '@/components/Pagination'
import SearchProfileInventory from '@/views/profile_inventories/Search'
import ImportProfileInventory from '@/views/profile_inventories/import'
import { formatFloat } from '@/utils/filter'
import { exportExcel } from '@/api/excel'

export default {
  name: 'ProfileInventoryList',
  components: {
    Pagination,
    SearchProfileInventory,
    ImportProfileInventory,
    DestroyProfileInventory: () => import('@/views/batch_operations/DestroyProfileInventory')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowImportModal: false,
      isShowDestroyModal: false,
      selectedRowKeys: [],
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    columns() {
      return [
        { title: 'ICCID', dataIndex: 'iccid', width: 200, fixed: 'left' },
        { title: 'MSISDN', dataIndex: 'msisdn', width: 140 },
        { title: '激活码', dataIndex: 'activation_code', width: 220, ellipsis: true },
        { title: 'MatchingID', dataIndex: 'matching_id', width: 160, ellipsis: true },
        { title: 'SM-DP+地址', dataIndex: 'smdp_address', width: 160, ellipsis: true },
        { title: 'SM-DP+平台', dataIndex: 'smdp_platform_name', width: 120 },
        { title: 'SGP协议', dataIndex: 'sgp_spec_name', width: 100 },
        { title: 'ProfileType', dataIndex: 'profile_type', width: 180, ellipsis: true },
        { title: 'PRP规则', dataIndex: 'prp_id_text', width: 200 },
        { title: '状态', dataIndex: 'status_text', width: 120 },
        { title: '下载次数', dataIndex: 'download_counter', width: 100 },
        { title: '供应商', dataIndex: 'profile_supplier_name', width: 140 },
        {
          title: 'Profile费(元)',
          dataIndex: 'profile_fee',
          width: 120,
          customRender: (t) => formatFloat(t)
        },
        { title: '备注', dataIndex: 'remark', width: 160, ellipsis: true },
        { title: '入库时间', dataIndex: 'created_at', width: 170 }
      ]
    },
    selectedIccids() {
      const idSet = new Set(this.selectedRowKeys)
      return this.data
        .filter((row) => idSet.has(row.id))
        .map((row) => row.iccid)
        .filter((iccid) => iccid)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    showImportModal() {
      this.isShowImportModal = true
    },

    showDestroyModal() {
      this.isShowDestroyModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findProfileInventories(this.query).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    },

    buildExportParams() {
      const params = Object.assign({}, this.query)
      if (this.selectedRowKeys.length > 0) {
        params.ids = this.selectedRowKeys.slice()
      }
      return params
    },

    exportData() {
      exportProfileInventories(this.buildExportParams()).then((res) => {
        if (res.code === 0 && res.data.is_direct_download) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>
